import { render, staticRenderFns } from "./TheConversationsDialog.vue?vue&type=template&id=b86b5f12&scoped=true"
import script from "./TheConversationsDialog.vue?vue&type=script&lang=js"
export * from "./TheConversationsDialog.vue?vue&type=script&lang=js"
import style0 from "./TheConversationsDialog.vue?vue&type=style&index=0&id=b86b5f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86b5f12",
  null
  
)

export default component.exports